
import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

/** Applied to the host while a drag is in progress (e.g. keep expanded UI when pointer leaves the element). */
const FREE_DRAGGING_CLASS = 'free-draggable-dragging';

@Directive({
  selector: '[appFreeDraggable]'
})
export class FreeDraggableDirective {
  private isDragging: boolean = false;
  private startX: number = 0;
  private startY: number = 0;
  
  @Input() enabled = true;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { 
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (!this.enabled || this.isInteractiveTarget(event)) {
      return;
    }
    // Do not preventDefault here — that kills click handlers on Mac/Safari.
    this.isDragging = true;
    const el = this.elementRef.nativeElement as HTMLElement;
    const position = getComputedStyle(el).position;
    if (position === 'fixed') {
      const rect = el.getBoundingClientRect();
      this.startX = event.clientX - rect.left;
      this.startY = event.clientY - rect.top;
      this.renderer.setStyle(el, 'left', `${Math.round(rect.left)}px`);
      this.renderer.setStyle(el, 'top', `${Math.round(rect.top)}px`);
      this.renderer.setStyle(el, 'bottom', 'auto');
      this.renderer.setStyle(el, 'right', 'auto');
      this.renderer.setStyle(el, 'transform', 'none');
    } else {
      this.startX = event.clientX - el.offsetLeft;
      this.startY = event.clientY - el.offsetTop;
    }
    this.renderer.addClass(this.elementRef.nativeElement, FREE_DRAGGING_CLASS);
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      const x = event.clientX - this.startX;
      const y = event.clientY - this.startY;
      this.renderer.setStyle(this.elementRef.nativeElement, 'left', `${x}px`);
      this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${y}px`);
    }
  }

  @HostListener('window:mouseup')
  onMouseUp() {
    if (this.isDragging) {
      this.renderer.removeClass(this.elementRef.nativeElement, FREE_DRAGGING_CLASS);
    }
    this.isDragging = false;
  }

  private isInteractiveTarget(event: MouseEvent): boolean {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    return path.some((node) => {
      if (!(node instanceof Element)) {
        return false;
      }
      const tag = node.tagName;
      return tag === 'ION-BUTTON' || tag === 'BUTTON' || tag === 'A' || tag === 'INPUT' || tag === 'TEXTAREA';
    });
  }
}